import React from 'react';
import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';
import { connect } from 'react-redux';

import { logoutUser } from '../../store/auth';
import Spinner from '../../components/Spinner/';

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

import CoreLayout from './layouts/PageLayout/PageLayout';
import ViewComponentRoute from './routes/ViewComponent';
import OnClickRoute from './routes/OneClick';

export const createRoutes = (store) => {
  return ({
    path: 'modules',
    component: connect(mapStateToProps)(props => {
      let GraphQLURI = __GraphQLPublic; // eslint-disable-line no-undef
      if (props.authedUserID !== null) {
        GraphQLURI = __GraphQLProtected; // eslint-disable-line no-undef
      }

      let ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            'Authorization': 'Bearer ' + (props.authedUser.rawToken || 'unauthed'),
          }
        }
      });

      let ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          <CoreLayout store={store} {...props} />
        </ApolloProvider>
      );
    }),
    childRoutes: [
      ViewComponentRoute(store),
      OnClickRoute(store),
      { // For Logging out the user
        path: 'logout',
        component: connect(
          mapStateToProps, {
            logoutUser,
          }
        )(class Logout extends React.Component {
          componentDidMount() {
            if (this.props.authedUserID !== null) {
              this.props.logoutUser();
            }

            window.location = 'https://www.paragonone.com';
          }

          render() {
            return (
              <Spinner />
            );
          }
        })
      },
    ]
  });
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/index.js